export class CmiInteractionObjectives{
	id
	n
	objective_id
	interaction_id
}